/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React, { useContext } from 'react';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import DeleteIcon from '@material-ui/icons/Delete';

import { useTranslation } from 'react-i18next';
import { CardContext } from '../CardContext';

export default function CardDeleteAction() {
  const { t } = useTranslation();
  const { anchorEl, handleClick, handleClose, handleDelete } = useContext(CardContext);

  return (
    <>
      <IconButton aria-label={t('actions.delete')} onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu id="customized-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem onClick={handleDelete} readOnly={!handleDelete}>
          <ListItemIcon>
            <DeleteIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Delete" />
        </MenuItem>
      </Menu>
    </>
  );
}
